import { Component } from '@angular/core';
import { GetClientRequest } from './models/client.model';

@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.scss']
})
export class ClientComponent {
  filter!: GetClientRequest;

  setFilter(filter: GetClientRequest) {
    this.filter = filter;
  }
}
